import { render, staticRenderFns } from "./travellingTrader.vue?vue&type=template&id=adea0766&scoped=true"
import script from "./travellingTrader.vue?vue&type=script&lang=js"
export * from "./travellingTrader.vue?vue&type=script&lang=js"
import style0 from "./travellingTrader.vue?vue&type=style&index=0&id=adea0766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adea0766",
  null
  
)

export default component.exports